/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Store_2Inputs */

const en_bot_store_2 = /** @type {(inputs: Bot_Store_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emails, phone numbers, ID numbers and tokens are masked before any text is stored or sent to an AI.`)
};

const id_bot_store_2 = /** @type {(inputs: Bot_Store_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email, nomor telepon, nomor identitas, dan token disamarkan sebelum teks disimpan atau dikirim ke AI.`)
};

/**
* | output |
* | --- |
* | "Emails, phone numbers, ID numbers and tokens are masked before any text is stored or sent to an AI." |
*
* @param {Bot_Store_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_store_2 = /** @type {((inputs?: Bot_Store_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Store_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_store_2(inputs)
	return en_bot_store_2(inputs)
});